import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import {
  GET_COLLECTION_ITEM,
  UPDATE_COLLECTION_ITEM,
} from "../actions";
import {
  getCollectionItemSuccess,
  getCollectionItemError,
  updateCollectionItemSuccess,
  updateCollectionItemError
} from "./actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";
const CollectionItemGetFailed = "Get collection item failed";
const CREATE_NEW_RECORD_ERROR = "New record success.";

export function* watchGetCollectionItem() {
  yield takeEvery(GET_COLLECTION_ITEM, getCollectionItem);
}

export function* watchUpdateCollectionItem() {
  yield takeEvery(UPDATE_COLLECTION_ITEM, updateCollectionItem);
}

const updateCollectionItemAsync = async (collectionItem) => {

  try {
    const responseObject = await centralApiAxios.put("nodes?id=" + collectionItem.node_response.node_id, collectionItem.node_response);

    return {
      newsItem: responseObject.data,
      node_id: responseObject.data.node_id,
      trashed: collectionItem.trashed,
      isNewsItemCreate: !(collectionItem.node_id > 0),
      message: ""
    };

  }
  catch (err) {
    // alert(err);
    return {
      message: "",
    };
  }
};

function* updateCollectionItem({ payload }) {
  const { history } = payload;
  try {
    const resultReturned = yield call(updateCollectionItemAsync, payload.collectionItem);
    if (!resultReturned.message) {
      yield put(updateCollectionItemSuccess(resultReturned));
      if (payload.newRecord && payload.newRecord.trashed == true) {
        history.push("/app/RecordListing/Collection");
        window.location.reload();
      }
      else if (payload.collectionItem && payload.collectionItem.node_response.trashed == true) {
        history.push("/app/RecordListing/collectionitem/" + payload.collectionItem.node_response.primary_collection_id + "/0/false")
        window.location.reload();
      }
      else {
        window.location.reload();
      }
    } else {
      yield put(updateCollectionItemError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(updateCollectionItemError(CREATE_NEW_RECORD_ERROR));
  }
}


const getCollectionItemAsync = async (payload) => {
  try {

    const dataReturned = await centralApiAxios.get("CollectionItems/" + payload.collectionItemId, getActivityHeadersUpdated(payload));
    if (dataReturned.data) {
      return {
        collectionItem: dataReturned.data,
        message: null,
      };
    }
    return { message: CollectionItemGetFailed };
  } catch (error) {
    return {
      message: CollectionItemGetFailed,
    };
  }
};

function* getCollectionItem({ payload }) {
  try {
    const returnedData = yield call(getCollectionItemAsync, payload);
    if (!returnedData.message) {
      yield put(
        getCollectionItemSuccess({
          collectionItem: returnedData.collectionItem,
        })
      );
    } else {
      yield put(getCollectionItemError(returnedData.message));
    }
  } catch (error) {
    yield put(getCollectionItemError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetCollectionItem),
    fork(watchUpdateCollectionItem)
  ]);
}
